import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Diamond, Loader2, Lock } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Bienvenue dans l'espace administrateur.");
      navigate("/admin");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-white/[0.04] border border-white/10 rounded-2xl px-4 py-3 text-sm text-[#F5F7F5] outline-none focus:border-[#D4AF37] transition-colors";

  return (
    <div className="min-h-screen bg-white/[0.04] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex items-center gap-2 mb-3">
            <Diamond className="w-6 h-6 text-[#D4AF37]" />
            <span className="font-display text-3xl text-[#F5F7F5]">GROZNY LOCATION</span>
          </div>
          <p className="text-[11px] tracking-luxe uppercase text-[#D4AF37]/80">Espace Administrateur</p>
        </div>
        <form onSubmit={submit} className="rounded-3xl border border-[#D4AF37]/20 bg-[#0E1512]/60 backdrop-blur-xl p-8 space-y-4" data-testid="admin-login-form">
          <div className="flex items-center gap-2 text-[#93A099] text-sm mb-2">
            <Lock className="w-4 h-4 text-[#D4AF37]" /> Accès réservé
          </div>
          <input required type="email" placeholder="Email" value={email} data-testid="login-email" onChange={(e) => setEmail(e.target.value)} className={inputCls} />
          <input required type="password" placeholder="Mot de passe" value={password} data-testid="login-password" onChange={(e) => setPassword(e.target.value)} className={inputCls} />
          <button type="submit" disabled={loading} data-testid="login-submit" className="w-full flex items-center justify-center gap-2 rounded-2xl bg-[#D4AF37] hover:bg-[#B8912A] text-white font-semibold py-3.5 text-sm tracking-widest uppercase transition-colors disabled:opacity-50">
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Se connecter
          </button>
        </form>
      </div>
    </div>
  );
}
